import { createPinService } from "./factory";

const pinService = createPinService();

export default pinService;
